import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["value", "getDayjsValue", "setValue", "onChangeTime"];
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import { useInstance } from 'intact-vue-next';
import { last } from '../utils';
import { useValue as useValueBase } from '../datepicker/basepicker';
import { NOW_START, NOW_END } from './constants';
export function useValue(formats, disabled, panel) {
  var instance = useInstance();
  var _useValueBase = useValueBase(formats, disabled, panel, function (v) {
      return false;
    }, function (v) {
      // pop the last value when input
      // because it is a placeholder date
      value.value.pop();
      setValue(v, true);
    }, function () {
      return 'second';
    }, function (dayjsValue, value) {
      value.set(_sliceInstanceProperty(dayjsValue).call(dayjsValue, 0));
    }),
    value = _useValueBase.value,
    getDayjsValue = _useValueBase.getDayjsValue,
    setValue = _useValueBase.setValue,
    onChangeTime = _useValueBase.onChangeTime,
    rest = _objectWithoutPropertiesLoose(_useValueBase, _excluded);
  setValue(getPlaceholderDates(), false);
  instance.watch('value', function (value) {
    var dayjsValue = getDayjsValue();
    setValue(last(dayjsValue) || getPlaceholderDates(), false);
  });
  function getPlaceholderDates() {
    return instance.get('range') ? [NOW_START, NOW_END] : NOW_START;
  }
  function onChangeTimeByStep(v, flag) {
    var date = formats.createDateByValueFormat(v);
    onChangeTime(date, flag);
  }
  return _extends({
    value: value,
    setValue: setValue,
    getDayjsValue: getDayjsValue,
    onChangeTime: onChangeTime,
    onChangeTimeByStep: onChangeTimeByStep
  }, rest);
}